import { Children, isValidElement, type FC, type ReactNode } from 'react';
import { cx } from '@linaria/atomic';
import { Icon, type IconName } from '@frontend/icons';
import { styles } from '../panel-feature-promotion-banner.styles';
import type {
  PanelFeaturePromotionBannerBulletProps,
  PanelFeaturePromotionBannerHighlightProps,
  PanelFeaturePromotionBannerHighlightsProps,
} from '../panel-feature-promotion-banner.types';

export const PanelFeaturePromotionBannerBullet: FC<PanelFeaturePromotionBannerBulletProps> = ({ className }) => {
  return (
    <span className={cx(styles.bullet, className)} aria-hidden='true'>
      •
    </span>
  );
};

export const PanelFeaturePromotionBannerHighlight: FC<PanelFeaturePromotionBannerHighlightProps> = ({
  children,
  icon,
  className,
  testId,
}) => {
  const iconContent = typeof icon === 'string' ? <Icon name={icon as IconName} /> : isValidElement(icon) ? icon : null;

  return (
    <span className={cx(styles.highlightItem, className)} data-testid={testId}>
      {iconContent && <span className={styles.highlightIcon}>{iconContent}</span>}
      <span className={styles.highlightText}>{children}</span>
    </span>
  );
};

export const PanelFeaturePromotionBannerHighlights: FC<PanelFeaturePromotionBannerHighlightsProps> = ({
  children,
  separator = 'none',
  className,
  testId,
}) => {
  const childArray = Children.toArray(children).filter(Boolean);

  const renderedContent =
    separator === 'bullet'
      ? childArray.reduce<ReactNode[]>((acc, child, index) => {
          if (index > 0) {
            acc.push(<PanelFeaturePromotionBannerBullet key={`bullet-${index}`} />);
          }
          acc.push(child);
          return acc;
        }, [])
      : childArray;

  return (
    <div className={cx(styles.highlights, className)} data-testid={testId}>
      {renderedContent}
    </div>
  );
};
